<template>
  <router-view />
</template>

<script>
export default {
  name: "Account"
}
</script>

<style scoped>

</style>